import { useMatches } from "react-router";

export function useLatestMatch() {
  const matches = useMatches();
  return matches[matches.length - 1];
}
